import { Icons } from '@/assets/icons/icons';
import { YStack } from '@/components/ui/layout/layout';
import { FeedRowAction } from '@/features/action-cards-view/feed/FeedRowActions';
import type { IntegrationSuggestion } from '@/features/integrations/integrations.types';

import { SuggestionTile } from './suggestion-tile';

import type { ReactNode, RefCallback } from 'react';

type SuggestionCardProps = {
  suggestion: IntegrationSuggestion;
  shownRef: RefCallback<HTMLDivElement>;
  title: ReactNode;
  message: ReactNode;
  badge?: ReactNode;
  actions?: ReactNode;
  dismiss?: { label: string; onClick: () => void; disabled?: boolean };
};

export const SuggestionCard = ({
  suggestion,
  shownRef,
  title,
  message,
  badge,
  actions,
  dismiss,
}: SuggestionCardProps) => (
  <YStack
    ref={shownRef}
    role="listitem"
    className="group/suggestion-card relative h-full min-w-0 overflow-hidden rounded-2xl border border-border-strong bg-surface"
  >
    <YStack className="relative min-w-0 flex-1 px-4 pb-4">
      <SuggestionTile
        suggestion={suggestion}
        className="mt-4 mb-2 size-12 rounded-[0.875rem]"
      >
        {badge}
      </SuggestionTile>
      <h3 className="min-w-0 break-words text-sm font-medium leading-5 text-foreground">
        {title}
      </h3>
      <p className="mt-2 min-w-0 break-words whitespace-pre-wrap text-sm leading-5 text-foreground-muted">
        {message}
      </p>
      {actions ? <div className="mt-auto pt-4">{actions}</div> : null}
    </YStack>
    {dismiss ? (
      <FeedRowAction
        icon={Icons.cancel}
        label="Dismiss"
        accessibleLabel={dismiss.label}
        disabled={dismiss.disabled}
        onClick={dismiss.onClick}
        className="ac-scale absolute right-2 top-2 z-10 opacity-0 transition-opacity duration-150 group-hover/suggestion-card:opacity-100 group-focus-within/suggestion-card:opacity-100 focus-visible:opacity-100 motion-reduce:transition-none"
      />
    ) : null}
  </YStack>
);
